module.exports = __webpack_public_path__ + "static/img/1_01.e787199.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd103/1_01.png
// module id = w0/B
// module chunks = 1